export enum IotNetwork {
  SIGFOX = 'SIGFOX',
  LORA = 'LORA',
  GPRS = 'GPRS',
}
